import React, { useEffect, useState } from "react";
import { BarChart3 } from "lucide-react";
import client from "@/lib/api";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

export default function AdminReports() {
  const [reports, setReports] = useState(null);
  useEffect(() => { client.get("/admin/reports").then((r) => setReports(r.data)).catch(() => {}); }, []);

  if (!reports) return <p className="px-4 pt-6 text-[13px]" style={{ color: "var(--k-ink-soft)" }}>جارٍ التحميل…</p>;

  return (
    <div dir="rtl">
      <h2 className="font-head text-[16px] font-bold px-4 pt-5 pb-2 flex items-center gap-1.5"><BarChart3 size={17} style={{ color: "var(--k-gold-deep)" }} /> التقارير</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 px-4 mb-2">
        {[["المبيعات (مدفوعة)", `${reports.salesTotal} د.ل`], ["إجمالي العمولات", `${reports.commissionTotal} د.ل`], ["صافي التجار", `${reports.netPayout} د.ل`], ["الطلبات", reports.ordersCount]].map(([l, v]) => (
          <div key={l} className="rounded-2xl p-3 text-center" style={{ background: "var(--k-surface)", border: "1px solid var(--k-line)" }}>
            <div className="font-num text-[15px] font-bold">{v}</div>
            <div className="text-[10px] mt-0.5" style={{ color: "var(--k-ink-soft)" }}>{l}</div>
          </div>
        ))}
      </div>
      <div className="rounded-2xl mx-4 mb-3 p-4" style={{ background: "var(--k-surface)", border: "1px solid var(--k-line)" }}>
        <p className="text-[12px] font-bold mb-2" style={{ color: "var(--k-ink-soft)" }}>المبيعات خلال 7 أيام</p>
        <div style={{ width: "100%", height: 200 }}>
          <ResponsiveContainer>
            <LineChart data={reports.salesSeries.map((s) => ({ day: s.day.slice(5), value: s.value }))} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="var(--k-line)" />
              <XAxis dataKey="day" tick={{ fontSize: 11, fill: "var(--k-ink-soft)" }} />
              <YAxis tick={{ fontSize: 10, fill: "var(--k-ink-soft)" }} width={44} />
              <Tooltip formatter={(v) => [`${v} د.ل`, "المبيعات"]} contentStyle={{ fontFamily: "Tajawal", fontSize: 12, direction: "rtl" }} />
              <Line type="monotone" dataKey="value" stroke="var(--k-gold)" strokeWidth={2.5} dot={{ r: 3, fill: "var(--k-gold-deep)" }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
      {reports.topProducts?.length > 0 && (
        <div className="rounded-2xl mx-4 mb-6 p-4" style={{ background: "var(--k-surface)", border: "1px solid var(--k-line)" }}>
          <p className="text-[12px] font-bold mb-2">الأكثر مبيعاً</p>
          {reports.topProducts.map((t, i) => (
            <div key={i} className="flex justify-between text-[12.5px] py-1" style={{ borderTop: i ? "1px solid var(--k-line)" : "none" }}>
              <span>{t.name}</span><span className="font-num font-bold">{t.qty}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
